import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import { SEO, Sticky } from '@/components';
import Carousel from '@/components/carousel/Carousel';
import { useBrandBannerTexts } from '@/hooks';
import { Menu } from '@/shared/menu';
import { withLayout } from '@/shared/withLayout';
import { useStores } from '@/stores';
import { BotList } from './botList';
import { HeroContainer, Wrapper } from './MyApps.sc';
import { UserApps } from './userApps';

const MyAppsPure: FC<{ headerHeight?: number }> = ({ headerHeight }) => {
  const { userStore, myAppsStore } = useStores();
  const { compatibilityStore } = useStores();
  const imagesAlt = useBrandBannerTexts();
  const { isUserAppsVisible, serviceWebHome } = myAppsStore;

  useEffect(() => {
    if (!userStore.isLoggedIn) {
      userStore.signInViaCLW();
      return;
    }

    myAppsStore.init();
    return () => myAppsStore.dispose();
  }, []);

  return (
    <React.Fragment>
      <SEO title={'Installed apps'} />
      {compatibilityStore.compatibility.headerBanners.length > 0 && (
        <HeroContainer>
          <Carousel
            images={compatibilityStore.compatibility.headerBanners}
            imagesAlt={imagesAlt}
          />
        </HeroContainer>
      )}
      <Sticky position="top" offset={headerHeight}>
        <Menu />
      </Sticky>
      <Wrapper data-test-automation-id="myAppsPage">
        {isUserAppsVisible && <UserApps url={serviceWebHome} />}
        <BotList />
      </Wrapper>
    </React.Fragment>
  );
};

export const MyApps = withLayout(observer(MyAppsPure), {
  stickyHeader: true,
});
